import type { IconData } from '@stacksjs/iconify-core'

export const basicUiSettings2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.465 6a4 4 0 1 1 0-4H15.5v4zM5.252 4a1.252 1.252 0 1 1-2.504 0a1.252 1.252 0 0 1 2.504 0m3.283 6H.5v4h8.035a4 4 0 1 0 0-4m4.717 2a1.252 1.252 0 1 1-2.504 0a1.252 1.252 0 0 1 2.504 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiSettings2
